import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import { useOutsideClick } from "@shared/hooks";
import { Icon } from "@shared/components/Icon";

import "./index.scss";

interface SelectButtonProps {
  text: string;
  children: React.ReactNode;
  isOpened: boolean;
  onCloseOpenSelect: (isOpened: boolean) => void;
}

const SelectButton = (props: SelectButtonProps) => {
  const { onCloseOpenSelect } = props;
  const ref = useRef(null);

  const [isOpenedSelect, setIsOpenedSelect] = useState(false);

  const { isOutside } = useOutsideClick(ref);

  useEffect(() => {
    if (!props.isOpened) {
      setIsOpenedSelect(false);
    }
  }, [props.isOpened]);

  useEffect(() => {
    onCloseOpenSelect(isOpenedSelect);
  }, [onCloseOpenSelect, isOpenedSelect]);

  useEffect(() => {
    if (isOutside) {
      setIsOpenedSelect(false);
    }
  }, [isOutside]);

  return (
    <div className="button-select-wrapper" ref={ref}>
      <div
        className={classnames("button-select", { active: isOpenedSelect })}
        onClick={() => setIsOpenedSelect(!isOpenedSelect)}
      >
        <div className="button-select-name">{props.text}</div>
        <div>
          <Icon type={isOpenedSelect ? "btn-open" : "btn-close"} />
        </div>
      </div>
      {isOpenedSelect ? <div className="button-select-items">{props.children}</div> : null}
    </div>
  );
};

export default SelectButton;
